import SetPasswordScreen from 'features/myVaro/screens/PersonalDetails/ConfirmPassword/SetPasswordScreen';
import React from 'react';

export default function ConfirmPasswordPage() {
  return <SetPasswordScreen />;
}
